// routes
import { PATH_AUTH, PATH_DOCS, PATH_PAGE } from "../../routes/paths";
// components
import { PATH_AFTER_LOGIN } from "../../config";
// components
import Iconify from "../../components/Iconify";

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22,
};

const items = [
  { title: "Accounting Services", path: "/services" },
  { title: "Tax Services", path: "/services" },
  { title: "Payroll", path: "/services" },
  { title: "Back‐office", path: "/services" },
  { title: "Advisory & Consultancy", path: "/services" },
  { title: "Statutory filings", path: "/services" },
  { title: "Company secretary", path: "/services" },
  { title: "IPR Services", path: "/services" },
  { title: "Licenses and permits", path: "/services" },
];

const menuConfig = [
  {
    title: "Home",
    icon: <Iconify icon={"eva:home-fill"} {...ICON_SIZE} />,
    path: "/",
  },
  {
    title: "Services",
    path: "/services",
    icon: null,
    children: [
      {
        subheader: "Services",
        items: items,
      },
    ],
  },
  {
    title: "Our Team",
    icon: null,
    path: "/our-team",
  },
  {
    title: "About Us",
    icon: null,
    path: "/",
  },
  {
    title: "Contact Us",
    icon: null,
    path: "/",
  },
];

export default menuConfig;
